module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "meet-the-team"
    }
  }, [_c('bc-navbar'), _vm._v(" "), (_vm.isLoadedPage) ? _c('div', {
    staticClass: "page_maincontent layout_fullwidth_padding"
  }, [_c('a', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.titlePage))]), _vm._v(" "), _vm._l((_vm.teamList), function(departmen, counter) {
    return _c('div', {
      key: counter
    }, [(departmen.departmentSales.length > 0) ? _c('h3', [_vm._v(_vm._s(departmen.departmentName))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "page_single layout_fullwidth_padding"
    }, [(departmen.departmentSales.length > 0) ? _c('div', {
      staticClass: "swiper-container-team  swiper-container-horizontal"
    }, [_c('div', {
      staticClass: "swiper-wrapper",
      staticStyle: {
        "transition-duration": "0ms",
        "transform": "translate3d(0px, 0px, 0px)"
      }
    }, _vm._l((departmen.departmentSales), function(teammate, index) {
      return _c('div', {
        key: index,
        staticClass: "swiper-slide team-block",
        on: {
          "touchstart": function($event) {
            return _vm.OnTouchStart($event)
          },
          "touchend": function($event) {
            return _vm.OnTouchEnd($event)
          },
          "click": function($event) {
            return _vm.OnItemClick(teammate, $event)
          }
        }
      }, [_c('div', {
        staticClass: "close-panel"
      }, [_c('img', {
        staticClass: "sales-photo",
        attrs: {
          "src": teammate.photo,
          "alt": "",
          "title": ""
        }
      }), _vm._v(" "), _c('strong', {}, [_vm._v(_vm._s(teammate.fullName))]), _vm._v(" "), _c('span', {
        style: ({
          'background-color': _vm.customization.mainColor,
          'color': _vm.customization.fontColor
        })
      }, [_vm._v("\n                                              " + _vm._s(teammate.title) + "\n                                            ")])])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination-team"
    }, [_c('span', {
      staticClass: "swiper-pagination-bullet swiper-pagination-bullet-active"
    }), _c('span', {
      staticClass: "swiper-pagination-bullet"
    }), _c('span', {
      staticClass: "swiper-pagination-bullet"
    }), _c('span', {
      staticClass: "swiper-pagination-bullet"
    })])]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoadedPage) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "top": "50%"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "left": "-50%"
    }
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 25,
      "color": _vm.customization.mainColor
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ab95910", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab95910"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/meet-the-team/meet-the-team.vue
// module id = 791
// module chunks = 0